import {Component, Prop, Vue} from 'vue-property-decorator'


@Component
export default class FormFieldMixin extends Vue {
    /**
     *
     */
    @Prop() name!: string
}
